<template>
  <div class="category-page">
    <div class="toolbar">
      <el-button type="primary" @click="openCreate">添加分类</el-button>
    </div>
    <el-table :data="list" style="width:100%" stripe>
      <el-table-column prop="id" label="ID" width="60"/>
      <el-table-column prop="name" label="名称"/>
      <el-table-column prop="slug" label="别名"/>
      <el-table-column prop="sort_order" label="排序" width="80"/>
      <el-table-column prop="status" label="状态" width="80">
        <template #default="{row}">
          <el-tag :type="row.status ? 'success' : 'info'">
            {{ row.status ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template #default="{row}">
          <el-button size="small" type="primary" @click="edit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog v-model="dialogVisible" title="分类信息" width="400px">
      <el-form :model="form" label-width="80px">
        <el-form-item label="名称">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="别名">
          <el-input v-model="form.slug" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort_order" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status">
            <el-option :value="1" label="启用" />
            <el-option :value="0" label="禁用" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitForm">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { ElMessage } from 'element-plus'
import request from '../../utils/request'
import store from '../../store'

const list = ref([])
const dialogVisible = ref(false)
const loading = ref(false)
const form = ref({ id: null, name: '', slug: '', sort_order: 0, status: 1 })

const loadList = async () => {
  try {
    list.value = await request.get('/v1/article-category/list')
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

const openCreate = () => {
  form.value = { id: null, name: '', slug: '', sort_order: 0, status: 1 }
  dialogVisible.value = true
}

const edit = (row) => {
  form.value = { ...row }
  dialogVisible.value = true
}

const submitForm = async () => {
  loading.value = true
  try {
    if (form.value.id) {
      await request.post('/v1/article-category/update', { ...form.value })
      ElMessage.success('更新成功')
    } else {
      await request.post('/v1/article-category/create', { ...form.value })
      ElMessage.success('创建成功')
    }
    dialogVisible.value = false
    loadList()
  } catch (e) {
    ElMessage.error(e.toString())
  } finally {
    loading.value = false
  }
}

const remove = async row => {
  try {
    await request.post('/v1/article-category/delete', { id: row.id })
    ElMessage.success('删除成功')
    loadList()
  } catch (e) {
    ElMessage.error(e.toString())
  }
}

onMounted(() => {
  if (store.state.token) {
    loadList()
  } else {
    watch(
      () => store.state.token,
      (t) => {
        if (t) {
          loadList()
        }
      },
      { immediate: true }
    )
  }
})
</script>

<style scoped>
.category-page .toolbar {
  margin-bottom: 15px;
}
</style>
